import EnumService from '../../jwt/enum.service';

export const OUTCOME_DISABLED_REASON_KEYS = {
  AUTHORITY_LIMIT: 'authorityLimit',
  CAUSA_OPENING_REQUIREMENTS: 'causaOpeningRequirements',
  ECONOMIC_NOT_CLOSED: 'economicNotClosed',
  GENERIC: 'generic',
  INSTANT_PAYMENT_UNAVAILABLE: 'instantPaymentUnavailable',
  LINKED_PAYMENT_EXISTS: 'linkedPaymentExists',
  LINKED_PAYMENT_REQUIRED: 'linkedPaymentRequired',
  MISSING_POLICY: 'missingPolicy',
  PAGAMENTO_EFFETTUATO_PITECO: 'pagamentoEffettuatoPiteco',
  PAGAMENTO_EFFETTUATO_SAP: 'pagamentoEffettuatoSap',
  PERIZIA_NEGATIVA_AFTER_CONFIRMED: 'periziaNegativaAfterConfirmed',
  PORTAL_MANAGED: 'portalManaged',
  RECOVERY_NOT_READY: 'recoveryNotReady',
  STORNO_SAP_SCADUTO: 'stornoSapScaduto',
  VALIDATION_PENDING: 'validationPending',
};

const normalizedDescription = (esito) => esito?.description?.toLowerCase();

export const getIncaricoDisabledReasonKey = ({
  esito,
  hasPagamentiCollegati,
  isSituazioneEconomicaChiusa,
  statoIncarico,
  portalEnabled = false,
}) => {
  const esitoDescription = normalizedDescription(esito);
  const normalizedStatoIncarico = statoIncarico?.toUpperCase();

  if (
    portalEnabled === true &&
    (
      EnumService.ESITI.INCARICO_CONFERMATO.includes(esitoDescription) ||
      EnumService.ESITI.PERIZIA_NEGATIVA.includes(esitoDescription) ||
      EnumService.ESITI.INCARICO_RIFIUTATO.includes(esitoDescription)
    )
  ) {
    return OUTCOME_DISABLED_REASON_KEYS.PORTAL_MANAGED;
  }

  if (EnumService.ESITI.INCARICO_COMPLETATO.includes(esitoDescription) && !hasPagamentiCollegati) {
    return OUTCOME_DISABLED_REASON_KEYS.LINKED_PAYMENT_REQUIRED;
  }

  if (
    (
      EnumService.ESITI.INCARICO_ANNULLATO.includes(esitoDescription) ||
      EnumService.ESITI.INCARICO_RIFIUTATO.includes(esitoDescription)
    ) &&
    hasPagamentiCollegati
  ) {
    return OUTCOME_DISABLED_REASON_KEYS.LINKED_PAYMENT_EXISTS;
  }

  if (EnumService.ESITI.CHIUSURA_INCARICO.includes(esitoDescription) && !isSituazioneEconomicaChiusa) {
    return OUTCOME_DISABLED_REASON_KEYS.ECONOMIC_NOT_CLOSED;
  }

  if (
    EnumService.ESITI.PERIZIA_NEGATIVA.includes(esitoDescription) &&
    ['EVASO', 'CONFERMATO'].includes(normalizedStatoIncarico)
  ) {
    return OUTCOME_DISABLED_REASON_KEYS.PERIZIA_NEGATIVA_AFTER_CONFIRMED;
  }

  return null;
};
